<template>
  <div class="index">

    <index-up-vue></index-up-vue>
    <index-down-vue></index-down-vue>
  </div>
</template>

<script>
  import IndexDownVue from './components/indexDownVue';
  import IndexUpVue from './components/indexUpVue';

  export default {
    name: "index",
    components: {
      IndexUpVue, IndexDownVue
    },
    created() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/mainView/index/index.vue